import React from 'react'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'

import { Tooltip, Button, message, Row, Col } from 'antd'
import { MinusSquareOutlined, PlusSquareOutlined, FilterOutlined, SyncOutlined, ColumnWidthOutlined, FileExcelOutlined, SaveOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-balham.css'

import nlMessages from './AgLocaleNL.json'

import common from '../../../common'

export default class AgGridWithState extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  //#region Load/Save Gridsettings
  loadFromLocalStorage = (key, defaultvalue) => {
    let storageObj = localStorage.getItem(key)
    try {
      storageObj = storageObj && JSON.parse(storageObj)
    } catch (e) {
      storageObj = defaultvalue //set back to default...
    }
    if (isEmpty(storageObj)) {
      storageObj = defaultvalue
    }
    return storageObj
  }

  loadGridSettings = () => {
    if (this.props.gridkey) {
      let savedstate = this.loadFromLocalStorage(
        `${this.props.gridkey}_GridSettings`,
        {},
      )
      if (!isEmpty(savedstate) && this.gridColumnApi.applyColumnState) {
        setTimeout(
          this.gridColumnApi.applyColumnState({
            state: savedstate,
            applyOrder: true,
          }),
          100,
        )
      } else {
        this.gridApi.sizeColumnsToFit()
      }
    }
  }
  saveGridSettings = (key, newcolstate) => {
    localStorage.setItem(`${key}_GridSettings`, JSON.stringify(newcolstate))
  }

  //#endregion

  redrawRows = (rowdata) => {
    this.gridApi.redrawRows() //setRowData(rowdata);
  }
  autosizeGrid = () => {
    this.gridApi.sizeColumnsToFit()
  }
  deselectAll = () => {
    this.gridApi.deselectAll()
  }
  getSelectedRowsData = () => {
    let selectedNodes = this.gridApi.getSelectedNodes()
    let selectedData = selectedNodes.map((node) => node.data)
    return selectedData
  }

  setNewValueByKey = (key, property, value) => {
    console.log('grid fn called...')
    var rowNode = this.gridApi.getRowNode(key)
    rowNode.setDataValue(property, value)
  }

  //#region btn handlers

  expandGroupsClick = (expand) => {
    if (expand) {
      this.gridApi.expandAll()
    } else {
      this.gridApi.collapseAll()
    }
  }
  clearFilters = () => {
    this.gridApi.setFilterModel(null)
  }
  exportCsv = () => {
    let params = {
      columnSeparator: '|',
      skipGroups: true,
      processCellCallback: function (params) {
        if (params.value && params.value instanceof Date) {
          return dayjs(params.value).format('DD-MM-YYYY')
        } else {
          return params.value
        }
      },
    }
    this.gridApi.exportDataAsExcel(params)
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.api
    if(this.props.onReady){
      this.props.onReady(params);
    }
  }
  onFirstDataRendered = (params) => {
    if (this.props.gridkey) {
      this.loadGridSettings()
    } else {
      params.api.sizeColumnsToFit()
      params.api.autoSizeColumns(['ag-Grid-AutoColumn'])
    }
  }
  onGridSizeChanged = (params) => {
    if (!this.props.gridkey) {
      params.api.sizeColumnsToFit()
    }
  }
  onGetContextMenu = (params) => {
    if (this.props.getContextMenuItems) {
      return this.props.getContextMenuItems(params)
    } else {
      console.log('nope')
    }
  }
  onRowSelected = (event) => {
    if (event.node.data && event.node.selected) {
      if (this.props.onItemSelected) {
        this.props.onItemSelected(event.node.data)
      }
    }
  }
  onRowDoubleClicked = (event) => {
    if (event.data) {
      if (this.props.onItemDoubleClicked) {
        this.props.onItemDoubleClicked(event.data, event.rowIndex)
      }
    }
  }
  onColumnMoved = (event) => {
    if (this.props.onColumnReorder) {
      const newcolOrder = this.gridApi.getAllDisplayedColumns().map(
        (col) => {
          return col.colId.replace('_1', '')
        },
      )
      this.props.onColumnReorder(newcolOrder)
    }
  }
  onColumnRowGroupChanged = (event) => {
    if (this.props.onGroupsChanged) {
      let colnames = event.columns.map((c) => c.colId.split('_')[0])
      this.props.onGroupsChanged(colnames)
    }
  }
  onSaveGridSettings = () => {
    if (this.props.gridkey) {
      let colstate = this.gridColumnApi.getColumnState()
      this.saveGridSettings(this.props.gridkey, colstate)
      message.success('saved')
    }
  }
  onClearGridSettings = () => {
    if (this.props.gridkey) {
      this.saveGridSettings(this.props.gridkey, {})
      message.success('saved')
      this.gridApi.sizeColumnsToFit()
    }
  }
  onRefresh = () => {
    if (this.props.onRefresh) {
      this.props.onRefresh()
    }
  }
  //#endregion

  label = (key) => {
    return common.getLabel(this.props.labels, 'common', 'GridLabels', key)
  }

  render() {
    let localeText = null
    let curLanguage = ''
    let curLocale = ''
    switch (this.props.lang) {
      case 1033:
        curLanguage = 'en-US'
        curLocale = 'en'
        break
      case 1043:
        curLanguage = 'nl-NL'
        curLocale = 'nl'
        localeText = nlMessages
        break
      default:
        curLanguage = 'en-US'
        curLocale = 'en'
    }

    //onderstaande ivm melding van AGGRid als key prop in collumndefinitioans zit...
    let coldefs = this.props.columnDefinitions.map((a) => ({ ...a }))
    coldefs = coldefs.filter(function (props) {
      delete props.key
      return true
    })

    return (
      <div>
        <Row>
          <Col span={12}>
            <Row
             
              align="middle"
              style={{
                height: '35px',
              }}
            >
              <Col>
                <Tooltip title={this.label('CollapseAll')}>
                  <MinusSquareOutlined style={{ marginLeft: 15, fontSize: '20px' }} onClick={() => this.expandGroupsClick(false)} />
                </Tooltip>
                <Tooltip title={this.label('ExpandAll')}>
                  <PlusSquareOutlined style={{ marginLeft: 5, fontSize: '20px' }} onClick={() => this.expandGroupsClick(true)} />
                </Tooltip>
                <Tooltip title={this.label('ClearAllFilters')}>
                  <FilterOutlined style={{ marginLeft: 25, fontSize: '20px' }} onClick={() => this.clearFilters()} />
                </Tooltip>
                {this.props.onRefresh && (
                  <Tooltip title={this.label('Refresh')}>
                    <SyncOutlined style={{ marginLeft: 15, fontSize: '20px' }} onClick={this.onRefresh} />
                  </Tooltip>
                )}
                <Tooltip title={this.label('Autosize')}>
                  <ColumnWidthOutlined style={{ marginLeft: 15, fontSize: '20px' }} onClick={() => this.gridApi.sizeColumnsToFit()} />
                </Tooltip>
                <Tooltip title={this.label('ExcelExport')}>
                  <FileExcelOutlined style={{ marginLeft: 15, fontSize: '20px' }} onClick={this.exportCsv} />
                </Tooltip>
              </Col>
            </Row>
          </Col>
          {this.props.gridkey && (
            <Col span={12}>
              <Row
               
                align="middle"
                justify="end"
                style={{
                  height: '35px',
                  paddingRight: '20px',
                }}
              >
                <Col>
                  <Tooltip title={this.label('SaveSettings')}>
                    <SaveOutlined style={{ marginLeft: 45, fontSize: '20px' }} onClick={this.onSaveGridSettings} />
                  </Tooltip>
                  <Tooltip title={this.label('LoadSettings')}>
                    <UploadOutlined style={{ marginLeft: 15, fontSize: '20px' }} onClick={this.loadGridSettings} />
                  </Tooltip>
                  <Tooltip title={this.label('ClearSettings')}>
                    <DeleteOutlined style={{ marginLeft: 25, fontSize: '20px' }} onClick={this.onClearGridSettings} />
                  </Tooltip>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
        <div
          className="ag-theme-balham"
          style={{
            height: `${this.props.height - 35}px`,
            width: '100%',
          }}
        >
          <AgGridReact
            statusBar={{
              statusPanels: [
                {
                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                  align: 'left',
                },
                {
                  statusPanel: 'agTotalRowCountComponent',
                  align: 'center',
                },
                { statusPanel: 'agFilteredRowCountComponent' },
                { statusPanel: 'agSelectedRowCountComponent' },
                { statusPanel: 'agAggregationComponent' },
              ],
            }} 
            headerHeight={this.props.HeaderHeight ? this.props.HeaderHeight :  undefined}
            cellSelection={true}
            sideBar={this.props.ShowSidebar}
            rowSelection={
              this.props.rowSelection === 'multiple' ? { mode: 'multiRow', checkboxes: true, headerCheckbox: false, hideDisabledCheckboxes: true, enableClickSelection: false, isRowSelectable: this.props.isRowSelectable } :
              typeof this.props.rowSelection === 'object' ? this.props.rowSelection :
              { mode: 'singleRow', checkboxes: false, headerCheckbox: false, enableClickSelection: true, isRowSelectable: this.props.isRowSelectable }
            }
            selectionColumnDef={{ hide: true }}
            onGridReady={this.onGridReady}
            getRowId={this.props.getRowNodeId ? (params) => String(this.props.getRowNodeId(params.data)) : undefined}
            autoGroupColumnDef={this.props.autoGroupColumnDef}
            onFirstDataRendered={this.onFirstDataRendered}
            rowGroupPanelShow={this.props.ShowGroupPanel ? 'always' : 'never'}
            suppressDragLeaveHidesColumns={true}
            suppressGroupChangesColumnVisibility="suppressShowOnUngroup"
            onRowSelected={this.onRowSelected}
            onRowDoubleClicked={this.onRowDoubleClicked}
            onGridSizeChanged={this.onGridSizeChanged}
            onColumnMoved={this.onColumnMoved}
            onColumnRowGroupChanged={this.onColumnRowGroupChanged}
            localeText={localeText}
            columnDefs={coldefs}
            components={this.props.frameworkComponents}
            rowData={this.props.data}
            groupDefaultExpanded={this.props.DefaultExpanded ? 1 : 0}
            rowClassRules={this.props.RowClassRules}
            groupMultiAutoColumn={this.props.GroupMultiAutoColumn}
            allowContextMenuWithControlKey={true}
            getContextMenuItems={this.onGetContextMenu}
                        defaultColDef={
              this.props.defaultColDef
                ? this.props.defaultColDef
                : { resizable: true, floatingFilter: true }
            }
          ></AgGridReact>
        </div>
      </div>
    )
  }
}
